module.exports = {
  dish1: {
    name: "Fish 1",
    description: "Insert Fish 1 description",
    price: 4000,
    status: "available"
  },
  dish2: {
    name: "Fish 2",
    description: "Insert Fish 2 description",
    price: 4200,
    status: "available"
  },
  dish3: {
    name: "Fish 3",
    description: "Insert Fish 3 description",
    price: 3200,
    status: "available"
  },
  dish4: {
    name: "Fish 4",
    description: "Insert Fish 4 description",
    price: 3400,
    status: "available"
  },
  dish5: {
    name: "Fish 5",
    description: "Insert Fish 5 description",
    price: 3500,
    status: "available"
  },
  dish6: {
    name: "Fish 6",
    description: "Insert Fish 6 description",
    price: 3000,
    status: "unavailable"
  },
  dish7: {
    name: "Fish 7",
    description: "Insert Fish 7 description",
    price: 2800,
    status: "available"
  },
  dish8: {
    name: "Fish 8",
    price: 4400,
    description: "Insert Fish 8 description",
    status: "available"
  },
  dish9: {
    name: "Fish 9",
    price: 3300,
    description: "Insert Fish 9 description",
    status: "available"
  },
  dish10: {
    name: "Fish 10",
    price: 3900,
    description: "Insert Fish 10 description",
    status: "available"
  }
};



// WEBPACK FOOTER //
// ./src/mockAPI/sample-stores-menus/Fishaways.js